import type {
  UpdateInvoicesReviewStatusRequestPayload,
  UpdateInvoicesReviewStatusResponse,
} from '@vy/api-definition';
import { UpdateInvoicesReviewStatusResponseSchema } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidateInvoicesQueries } from '../../utils/query-invalidation';

type UpdateInvoiceReviewStatusPayload = UpdateInvoicesReviewStatusRequestPayload & {
  customerIds: string[];
};

export function useUpdateInvoicesReviewStatuses(
  options?: UseMutationOptions<
    UpdateInvoicesReviewStatusResponse,
    unknown,
    UpdateInvoiceReviewStatusPayload,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  return useMutation(async (requestPayload) => {
    const { invoicesByNewStatus } = requestPayload;
    const invoicesApi = getPrivateApi();
    const updateInvoiceReviewStatusResponse = await invoicesApi.updateInvoicesReviewStatuses({
      updateInvoicesReviewStatusesRequest: { invoicesByNewStatus },
    });

    return UpdateInvoicesReviewStatusResponseSchema.parse(updateInvoiceReviewStatusResponse);
  }, {
    onSuccess: async () => {
      await invalidateInvoicesQueries(queryClient);
    },
    ...options,
  });
}
